module.exports = __webpack_public_path__ + "static/assets/ca81e298812f54aa66da9e641b34058d.png";